import { useQuery } from '@tanstack/react-query';
import { api } from './api';
import type { BillingAction, PlanTier, SubscriptionInfo } from './billing.types';

/**
 * React Query hooks for /api/v1/billing endpoints.
 */

export function useSubscription() {
  return useQuery({
    queryKey: ['billing', 'subscription'],
    queryFn: async () => {
      const r = await api.get<SubscriptionInfo>('/billing/subscription');
      return r.data;
    },
    staleTime: 60_000,       // subscription rarely changes mid-session
    retry: false,             // 404 = no subscription yet, don't spam
  });
}

export function useCheckoutUrl() {
  return useQuery({
    queryKey: ['billing', 'checkout'],
    // This is a manual trigger — we'll use a mutation instead.
    enabled: false,
    queryFn: async () => null,
  });
}

/**
 * Create a Stripe Checkout Session for a given plan tier.
 * Returns the redirect URL.
 */
export async function createCheckoutSession(planTier: PlanTier): Promise<BillingAction> {
  const r = await api.post<BillingAction>('/billing/create-checkout', { planTier });
  return r.data;
}

/**
 * Create a Stripe Customer Portal session.
 * Returns the redirect URL.
 */
export async function createPortalSession(): Promise<BillingAction> {
  const r = await api.get<BillingAction>('/billing/portal');
  return r.data;
}
